import { Card } from "@mui/material";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Pagination from "components/Pagination";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import Table from "components/Tables/Table";
import Loader from "components/loader";
import DashboardLayout from "layouts/DashboardLayout";
import { useEffect, useState } from "react";
import businessEnquiryListing from "./components/businessEnquiryListing";
// import { useSnackbar } from "notistack";
import { APP_CONSTANTS } from "App.constant";
import { useNavigate } from "react-router-dom";
import BusinessEnquiryViewModal from "./components/businessEnquiryViewModal";

function BusinessEnquiryPage() {
    const defaultEnquiryObject = {
        'name': '',
        'email': '',
        'phone_number': '',
        'enquiry_type': '',
        'description': '',
        'company_name': '',
        'job_title': '',
        'source': '',
        // 'resolve_status': ''
    }
    const [currentEnquiryData, setCurrentEnquiryData] = useState(defaultEnquiryObject);
    const [viewPopup, setViewPopup] = useState(false);
    const [columns, setColumns] = useState([]);
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    // const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();

    useEffect(() => {
        if (localStorage.getItem('isLoggedIn') === null || localStorage.getItem('isLoggedIn').toString() === 'false') {
            navigate('/', { replace: true });
        }
        getBlogCategoriesData(page);
    }, []);

    const handleViewData = (data) => {
        setCurrentEnquiryData(data);
        setViewPopup(true);
    }

    const getBlogCategoriesData = (pageNumber) => {
        setIsLoading(true);
        const token = "Bearer " + JSON.parse(localStorage.getItem('userData'))['token'];
        fetch(process.env.REACT_APP_API_URL + 'business-enquiries/summary?page=' + pageNumber, {
            method: 'GET',
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": token
            }
        })
            .then(response => response.json())
            .then((responseData) => {
                if (responseData.statusCode === 200) {
                    responseData = responseData.data;
                    const finalEnquiryData = businessEnquiryListing(responseData.enquires, handleViewData);
                    setColumns(finalEnquiryData.columns);
                    setRows(finalEnquiryData.rows);
                    setTotalCount(responseData.totalCount);
                    setTotalPages(Math.ceil(responseData.totalCount / 10));
                }
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
            });
    };

    return <>
        <DashboardLayout>
            <DashboardNavbar />
            <BusinessEnquiryViewModal
                show={viewPopup}
                headerTitle={'View Business Enquiry'}
                bodyData={currentEnquiryData}
                closeAction={{
                    color: 'info',
                    title: 'Cancel',
                }}
                handleClose={() => {
                    setViewPopup(false);
                }} />
            <SoftBox py={3}>
                <SoftBox mb={3}>
                    <Card>
                        {
                            !isLoading ? <>
                                <SoftBox
                                    sx={{
                                        "& .MuiTableRow-root:not(:last-child)": {
                                            "& td": {
                                                borderBottom: ({ borders: { borderWidth, borderColor } }) =>
                                                    `${borderWidth[1]} solid ${borderColor}`,
                                            },
                                        },
                                    }}
                                >
                                    {
                                        totalCount > 0 ?
                                            <Table
                                                columns={columns}
                                                rows={rows} /> :
                                            <SoftBox display="flex" flexDirection="column" style={{
                                                "alignItems": "center",
                                                "margin": "16px"
                                            }}>
                                                <SoftTypography variant="button" fontWeight="medium">
                                                    No Data Found
                                                </SoftTypography>
                                            </SoftBox>
                                    }
                                </SoftBox>
                            </> : <>
                                <Loader classes='black' />
                            </>
                        }
                        {
                            !isLoading && totalCount > 0 && <>
                                <Pagination
                                    maxPages={totalPages}
                                    currentPage={page}
                                    onPageChange={(pageNumber) => {
                                        setPage(pageNumber);
                                        getBlogCategoriesData(pageNumber);
                                    }} />
                            </>
                        }
                    </Card>
                </SoftBox>
            </SoftBox>
        </DashboardLayout>
    </>;
}

export default BusinessEnquiryPage;